import _objectSpread from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["className", "disabled", "onClick", "style", "tabIndex", "theme", "mintTo", "emailTo", "listingId", "clientId", "auctionId", "hideMintOnInactiveClient", "showOverlay", "mintConfig", "whPassThroughArgs", "environment", "paymentMethod", "preferredSigninMethod", "dismissOverlayOnClick", "prepay", "locale", "currency"],
  _excluded2 = ["className", "disabled", "onClick", "style", "tabIndex", "theme", "clientId", "auctionId", "platformId", "mintConfig", "environment", "locale"];
import c, { useEffect as X, useMemo as Z } from "react";
import { useState as O } from "react";
import { clientNames as L, crossmintModalService as tt, crossmintPayButtonService as st, crossmintStatusService as ot, mintingContractTypes as et, onboardingRequestStatusResponse as nt } from "@crossmint/client-sdk-base";
import { createUseStyles as Y } from "react-jss";
var z = "#1e1e1e",
  H = function H(t) {
    return t === "light";
  },
  b = function b(t) {
    return {
      buttonBgColor: H(t) ? "white" : z,
      paragraphColor: H(t) ? "black" : "white"
    };
  },
  I = Y({
    "@global": {
      "@import": "url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap')"
    },
    crossmintButton: {
      display: "flex",
      "flex-direction": "row",
      "align-items": "center",
      padding: "0.875rem 0.875rem",
      "font-weight": "900",
      transition: "opacity ease-in-out 0.25s",
      "border-radius": "0.5rem",
      "font-family": '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
      outline: "none",
      border: "none",
      "box-shadow": "0px 8px 15px rgba(0, 0, 0, 0.1)",
      "justify-content": "center",
      background: function background(_ref) {
        var t = _ref.buttonBgColor;
        return t;
      },
      "&:hover:enabled": {
        opacity: "0.6",
        cursor: "pointer"
      }
    },
    crossmintImg: {
      width: "21px",
      height: "21px",
      "margin-right": "0.875rem"
    },
    crossmintParagraph: {
      color: function color(_ref2) {
        var t = _ref2.paragraphColor;
        return t;
      },
      margin: "0"
    }
  });
import { useEffect as J, useState as Q } from "react";
function a() {
  var _Q = Q(!0),
    _Q2 = _slicedToArray(_Q, 2),
    t = _Q2[0],
    u = _Q2[1];
  return J(function () {
    u(!1);
  }, []), {
    isServerSideRendering: t
  };
}
var m = "0.2.2-alpha.1";
var rt = {
    type: et.CANDY_MACHINE
  },
  Et = function Et(_ref3) {
    var t = _ref3.className,
      u = _ref3.disabled,
      h = _ref3.onClick,
      y = _ref3.style,
      B = _ref3.tabIndex,
      _ref3$theme = _ref3.theme,
      v = _ref3$theme === void 0 ? "dark" : _ref3$theme,
      x = _ref3.mintTo,
      N = _ref3.emailTo,
      P = _ref3.listingId,
      p = _ref3.clientId,
      E = _ref3.auctionId,
      _ref3$hideMintOnInact = _ref3.hideMintOnInactiveClient,
      g = _ref3$hideMintOnInact === void 0 ? !1 : _ref3$hideMintOnInact,
      _ref3$showOverlay = _ref3.showOverlay,
      M = _ref3$showOverlay === void 0 ? !0 : _ref3$showOverlay,
      _ref3$mintConfig = _ref3.mintConfig,
      s = _ref3$mintConfig === void 0 ? rt : _ref3$mintConfig,
      U = _ref3.whPassThroughArgs,
      S = _ref3.environment,
      f = _ref3.paymentMethod,
      d = _ref3.preferredSigninMethod,
      k = _ref3.dismissOverlayOnClick,
      w = _ref3.prepay,
      _ref3$locale = _ref3.locale,
      C = _ref3$locale === void 0 ? "en-US" : _ref3$locale,
      _ref3$currency = _ref3.currency,
      R = _ref3$currency === void 0 ? "USD" : _ref3$currency,
      o = _objectWithoutProperties(_ref3, _excluded);
    var _O = O(!1),
      _O2 = _slicedToArray(_O, 2),
      e = _O2[0],
      n = _O2[1],
      _O3 = O(nt.WAITING_SUBMISSION),
      _O4 = _slicedToArray(_O3, 2),
      T = _O4[0],
      V = _O4[1],
      _a = a(),
      A = _a.isServerSideRendering,
      _ot = ot({
        libVersion: m,
        clientId: p,
        environment: S,
        auctionId: E,
        mintConfig: s,
        setStatus: V,
        clientName: L.reactUi
      }),
      F = _ot.fetchClientIntegration,
      _tt = tt({
        clientId: p,
        showOverlay: M,
        dismissOverlayOnClick: k,
        setConnecting: n,
        libVersion: m,
        environment: S,
        clientName: L.reactUi,
        locale: C,
        currency: R
      }),
      $ = _tt.connect,
      _st = st({
        onClick: h,
        connecting: e,
        paymentMethod: f,
        locale: C
      }),
      D = _st.getButtonText,
      G = _st.shouldHideButton,
      q = _st.handleClick;
    X(function () {
      g && F();
    }, [T]);
    var W = function W(K) {
        return q(K, function () {
          $(s, x, N, P, U, f, d, w);
        });
      },
      _ = I(b(v)),
      j = Z(function () {
        return c.createElement("span", {
          className: _.crossmintParagraph,
          role: "button-paragraph"
        }, D(e));
      }, [e]);
    return G({
      hideMintOnInactiveClient: g,
      status: T
    }) ? null : c.createElement(c.Fragment, null, !A && c.createElement("button", _objectSpread({
      className: "".concat(_.crossmintButton, " ").concat(t || ""),
      disabled: u,
      onClick: W,
      style: _objectSpread({}, y),
      tabIndex: B
    }, o), c.createElement("img", {
      className: _.crossmintImg,
      src: "https://www.crossmint.io/assets/crossmint/logo.svg",
      alt: "Crossmint logo"
    }), j));
  };
import l, { useEffect as it, useMemo as at, useState as mt } from "react";
import { baseUrls as ct, clientNames as lt, crossmintStatusButtonService as ut, crossmintStatusService as pt, onboardingRequestStatusResponse as gt } from "@crossmint/client-sdk-base";
var Ot = function Ot(_ref4) {
  var t = _ref4.className,
    u = _ref4.disabled,
    h = _ref4.onClick,
    y = _ref4.style,
    B = _ref4.tabIndex,
    _ref4$theme = _ref4.theme,
    v = _ref4$theme === void 0 ? "dark" : _ref4$theme,
    x = _ref4.clientId,
    N = _ref4.auctionId,
    P = _ref4.platformId,
    p = _ref4.mintConfig,
    E = _ref4.environment,
    _ref4$locale = _ref4.locale,
    g = _ref4$locale === void 0 ? "en-US" : _ref4$locale,
    M = _objectWithoutProperties(_ref4, _excluded2);
  var _mt = mt(gt.WAITING_SUBMISSION),
    _mt2 = _slicedToArray(_mt, 2),
    s = _mt2[0],
    U = _mt2[1],
    _a2 = a(),
    S = _a2.isServerSideRendering,
    _pt = pt({
      libVersion: m,
      clientId: x,
      environment: E,
      platformId: P,
      auctionId: N,
      mintConfig: p,
      setStatus: U,
      clientName: lt.reactUi
    }),
    f = _pt.goToOnboarding,
    d = _pt.fetchClientIntegration,
    _ut = ut({
      onClick: h,
      locale: g
    }),
    k = _ut.getButtonText,
    w = _ut.isButtonDisabled,
    C = _ut.handleClick,
    R = function R(n) {
      return C(n, s, f);
    };
  it(function () {
    d();
    var n = setInterval(function () {
      d();
    }, 60 * 1e3);
    return function () {
      return clearInterval(n);
    };
  }, []);
  var o = I(b(v)),
    e = at(function () {
      return l.createElement("span", {
        className: o.crossmintParagraph
      }, k(s));
    }, [s]);
  return l.createElement(l.Fragment, null, !S && l.createElement("button", _objectSpread({
    className: "".concat(o.crossmintButton, " ").concat(t || ""),
    disabled: w(s),
    onClick: R,
    style: _objectSpread({}, y),
    tabIndex: B
  }, M), l.createElement("img", {
    className: o.crossmintImg,
    src: "".concat(ct.prod, "/assets/crossmint/logo.svg"),
    alt: "Crossmint logo"
  }), e));
};
export { Et as CrossmintPayButton, Ot as CrossmintStatusButton };